// ── Общие хуки экранов ───────────────────────────────────────────────────────
// useAudioTime — текущее время звука без перерисовки всего плеера на каждый тик;
// useOneShot — выполнить запрос от родителя ровно один раз (переживает перемонтирование).

import { useEffect, useState } from "react";

// Текущее время аудио — подписка прямо на элемент, без перерисовки всего приложения.
export function useAudioTime(audio,fallback=0){
  const [t,setT]=useState(()=>audio?audio.currentTime:fallback);
  useEffect(()=>{
    if(!audio)return;
    const on=()=>setT(audio.currentTime);
    on();
    audio.addEventListener("timeupdate",on);audio.addEventListener("seeked",on);
    return()=>{audio.removeEventListener("timeupdate",on);audio.removeEventListener("seeked",on);};
  },[audio]);
  return audio?t:fallback;
}

// ── MiniPlayer — мини-плеер внизу экрана (фоновое аудио) ────────────────────

// Разовый запрос от App («открой повторение», «новая папка»): срабатывает один раз,
// даже если экран смонтировался уже после нажатия.
export const _handledReq={};
export function useOneShot(name,req,fn){
  useEffect(()=>{if(req&&req!==_handledReq[name]){_handledReq[name]=req;fn();}// eslint-disable-next-line react-hooks/exhaustive-deps
  },[req]);
}
